import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    popupStates: {
        id: "",
        value: false,
    }
}

const globalSlice = createSlice({
    name: "global",
    initialState,
    reducers: {
        setPopupState: (state, action) => {
            state.popupStates = action.payload;
        }
    },
    extraReducers: (builder) => {

    }
});

export const { setPopupState } = globalSlice.actions;
export default globalSlice.reducer;